import { Component } from '@angular/core';

@Component({
  selector: 'app-granth-seller-update-print-order',
  standalone: true,
  imports: [],
  templateUrl: './granth-seller-update-print-order.component.html',
  styleUrl: './granth-seller-update-print-order.component.scss'
})
export class GranthSellerUpdatePrintOrderComponent {

}
